<template>
	<sf-data-table ref="dataTable" :columns="groupMapCols" :rows="groups" selection @selection-change="handleSelectionChange" />
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupMap/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			multipleSelection: [],
			selectedUser: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		groupMapCols() {
			return [
				{
					label: this.getMessage_('SWCC000959'), //사용자그룹 권한 코드
					prop: 'permGrpCd',
					minWidth: '180px'
				},
				{
					label: this.getMessage_('SWCC000958'), //사용자그룹 권한명
					prop: 'userGrpName',
					minWidth: '180px'
				},
				{
					label: this.getMessage_('SWCC000891'), //사용여부
					prop: 'useYn',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('SWCC000004'), //작성일
					prop: 'regDt',
					minWidth: '150px'
				},
				{
					label: this.getMessage_('SWCC000005'), //작성자
					prop: 'regId',
					minWidth: '150px'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		getData(param) {
			// this.selectedUser = param.userId.trim();
			this.selectedUser = param.userId;
			let params = {
				plantCd: this.searchParams.plantCd,
				userId: this.selectedUser
			};
			this.$sf_toggleLoading(true);
			this.getGroups_(params)
				.then(() => {
					this.getUserMappingGroups_(params)
						.then(() => {
							this.$refs.dataTable.clearSelection();
							this.mappingGroups.forEach(ele => {
								this.$refs.dataTable.getTable().toggleRowSelection(this.groups[this.groups.findIndex(row => row.permGrpCd == ele)]);
							});
						})
						.catch(error => {
							this.$sf_toast({
								type: 'error',
								message: error.message
							});
							Promise.reject(error);
						})
						.finally(() => {
							this.$sf_toggleLoading(false);
						});
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
					this.$sf_toggleLoading(false);
				})
				.finally(() => {});
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		resetTable() {
			this.getData({ userId: this.selectedUser });
			this.mappingGroups.forEach(ele => {
				this.$refs.dataTable.toggleRowSelection(this.groups[this.groups.findIndex(row => row.permGrpCd == ele)]);
			});
		},
		save() {
			// console.log('@@@@ this.selectedUser: ', this.selectedUser);
			let saveData = {
				status: 1,
				plantCd: this.searchParams.plantCd,
				userId: this.selectedUser,
				data: []
			};

			let deleteData = {
				status: 3,
				plantCd: this.searchParams.plantCd,
				userId: this.selectedUser,
				data: []
			};

			let selectedGroupCds = [];
			this.multipleSelection.forEach(row => {
				selectedGroupCds.push(row.permGrpCd);
				if (this.mappingGroups.findIndex(item => item == row.permGrpCd) < 0) {
					let pushSet = {
						permGrpCd: row.permGrpCd,
						regId: 'ADMIN'
					};
					saveData.data.push(pushSet);
				}
			});

			// console.log('@@@@ saveData: ', saveData);

			this.mappingGroups.forEach(ele => {
				if (selectedGroupCds.length < 1 || (selectedGroupCds.length > 0 && selectedGroupCds.findIndex(item => item == ele) < 0)) {
					let pushSet = {
						permGrpCd: ele
					};
					deleteData.data.push(pushSet);
				}
			});

			if (saveData.data != undefined && saveData.data.length > 0) {
				// console.log('@@@@ saveData: ', saveData);
				this.$sf_toggleLoading(true);
				this.setGroups_(saveData)
					.then(response => {
						if (response.message != undefined && response.message != null) {
							this.resetTable();
							this.$sf_toast({
								type: response.code === 0 ? 'ok' : 'error',
								message: response.message
							});
						}
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}

			if (deleteData.data != undefined && deleteData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setGroups_(deleteData)
					.then(response => {
						if (response.message != undefined && response.message != null) {
							this.resetTable();
							this.$sf_toast({
								type: response.code === 0 ? 'ok' : 'error',
								message: response.message
							});
						}
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		saveClick() {
			const selected = this.multipleSelection;

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			this.$sf_showMessage({
				icon: 'confirm',
				type: 'confirm',
				message: this.getMessage_('SWCC000501'),
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		}
	}
};
</script>

<style></style>
